import "core-js/modules/es6.object.create";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
/* global window */


import React, { Component } from 'react';
import { mediaUrl } from '@wingscms/sdk';
import styled from 'styled-components';
import widont from 'widont';
var ImageContainer = styled.figure.withConfig({
  displayName: "Header__ImageContainer",
  componentId: "g7ldjy-0"
})(["margin:", " 0 0 0;width:100%;@media screen and (min-width:800px){margin:", " 0 0 50%;max-width:1200px;width:100vw;transform:translateX(-50%);padding:0 20px;}img{width:100%;display:block;margin:0;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.mediumSpacing;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.largeSpacing;
});
var TitleContainer = styled.div.withConfig({
  displayName: "Header__TitleContainer",
  componentId: "g7ldjy-1"
})(["padding:0;position:relative;text-align:center;margin-top:", ";@media screen and (min-width:800px){margin-top:", ";}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.mediumSpacing;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.largeSpacing;
});
var Title = styled.h1.withConfig({
  displayName: "Header__Title",
  componentId: "g7ldjy-2"
})(["letter-spacing:1.5px;color:", ";text-transform:", ";display:inline-block;font-size:2rem;line-height:1.2;text-align:center;margin:0 auto 0 auto;max-width:90%;position:relative;z-index:2;@media screen and (min-width:600px){font-size:2.5rem;}@media screen and (min-width:800px){font-size:3rem;}@media screen and (min-width:960px){width:920px;}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.textColor;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.uppercaseTitles ? 'uppercase' : 'none';
});

var Header =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Header, _Component);

  function Header() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Header.prototype;

  _proto.render = function render() {
    var article = this.props.article;
    var title = widont(article.title);
    var image = article && article.image && article.image.url || '';
    return React.createElement(TitleContainer, null, React.createElement(Title, null, title), image ? React.createElement(ImageContainer, null, React.createElement("img", {
      src: mediaUrl(image, {
        width: 1160
      }),
      alt: image.caption
    })) : null);
  };

  return Header;
}(Component);

export { Header as default };